import React from 'react';
import { ShareIcon } from 'icons/share';
import { IconButton } from './IconButton';

export function CustomShareButton() {
  return <IconButton icon={<ShareIcon />} />;
}
